// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"YyaXQh","input":"SrY9XI"};